<div class="property-options">
  <label class="input-label" for="closing-agency"
    >{{ label }}
    @if (required) {
      <sup class="required">*</sup>
    }
  </label>
  <div class="max-width-400">
    <p-select
      [formControl]="control"
      optionValue="value"
      [options]="options"
      optionLabel="label"
      placeholder="Select..."
      (onChange)="selectOption.emit($event.value)" />
  </div>
</div>
